import { lazy, Suspense } from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import TrustBanner from "@/components/TrustBanner";
import FloatingCTA from "@/components/FloatingCTA";

const ServicesSection = lazy(() => import("@/components/ServicesSection"));
const MidPageCTA = lazy(() => import("@/components/MidPageCTA"));
const BeforeAfterSection = lazy(() => import("@/components/BeforeAfterSection"));
const GallerySection = lazy(() => import("@/components/GallerySection"));
const TestimonialsSection = lazy(() => import("@/components/TestimonialsSection"));
const WhyUsSection = lazy(() => import("@/components/WhyUsSection"));
const PartnersSection = lazy(() => import("@/components/PartnersSection"));
const ZoneSection = lazy(() => import("@/components/ZoneSection"));
const ContactSection = lazy(() => import("@/components/ContactSection"));
const FooterSection = lazy(() => import("@/components/FooterSection"));

const Index = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <TrustBanner />
      <Suspense fallback={<div className="min-h-[200px]" />}>
        <ServicesSection />
        <MidPageCTA />
        <BeforeAfterSection />
        <GallerySection />
        <TestimonialsSection />
        <WhyUsSection />
        <PartnersSection />
        <ZoneSection />
        <ContactSection />
        <FooterSection />
      </Suspense>
      <FloatingCTA />
    </div>
  );
};

export default Index;
